import React from 'react';

import logoAutosColorSVG from '../assets/logos/gs-logo-autos-color.svg';
import mapMarkerWhiteSVG from '../assets/svg-icons/map-marker-white.svg';
import phoneWhiteSVG from '../assets/svg-icons/phone-white.svg';
import mailWhiteSVG from '../assets/svg-icons/mail-white.svg';
import facebookWhiteSVG from '../assets/svg-icons/facebook-white.svg';
import instagramWhiteSVG from '../assets/svg-icons/instagram-white.svg';
import youtubeWhiteSVG from '../assets/svg-icons/youtube-white.svg';
import gsLogoWhite from '../assets/logos/general_de_seguros_logo.png';

import privacyStatementPDF from '../assets/pdf/Aviso-de-Privacidad-GS-Autos.pdf';
import usePolicyPDF from '../assets/pdf/Politica-de-Uso-GS-Autos.pdf';
import termsAndConditionsPDF from '../assets/pdf/Terminos-y-Condiciones-GS-Autos.pdf';
import termsAndConditionsChristasF2 from '../assets/pdf/TYC-NAVIDAD-2025-F2.pdf';
import { getImageURL } from '../utils/helper-functions';

const FooterContainer = () => {
  return (
    <div className="footer">
      <div className="contact">
        <div className="contact-info">
          <div className="img-logo">
            <img className="logo" src={logoAutosColorSVG} alt="General de Seguros Autos Logo" />
            <img className="logo" alt="General de Seguros" src={gsLogoWhite} />
          </div>
          <div className="info-row">
            <div className="icon">
              <img src={mapMarkerWhiteSVG} alt="Dirección" />
            </div>
            <p>
              Av. Patriotismo # 266 Col. San Pedro de los Pinos, C.P. 03800, Benito Juárez, CDMX
            </p>
          </div>
          <div className="info-row">
            <div className="icon">
              <img src={phoneWhiteSVG} alt="Teléfono AMAE" />
            </div>
            <p>
              <a href="tel:8002884747">
                800 288 4747
              </a>
            </p>
          </div>
          <div className="info-row">
            <div className="icon">
              <img src={mailWhiteSVG} alt="Correo electrónico" />
            </div>
            <p>
              <a target="_blank" rel="noreferrer" href="mailto:atencionaclientes@gseguros.com.mx">
                atencionaclientes@gseguros.com.mx
              </a>
            </p>
          </div>
        </div>

        <div className="contact-links">
          <p>
            <a href={getImageURL(privacyStatementPDF)} rel="noreferrer" target="_blank">Aviso de Privacidad</a>
          </p>
          <p>
            <a href={getImageURL(termsAndConditionsPDF)} rel="noreferrer" target="_blank">Términos y condiciones</a>
          </p>
          <p>
            <a href={getImageURL(usePolicyPDF)} rel="noreferrer" target="_blank">Políticas de uso</a>
          </p>
          <p>
            <a href={getImageURL(termsAndConditionsChristasF2)} rel="noreferrer" target="_blank">
              Términos y Condiciones Navidad 2025
            </a>
          </p>
        </div>
        <hr />

        <div className="social">
          <p className="mb-25">
            Todos los derechos reservados.
            <br />
            General de Seguros 2023.
          </p>
          <div className="media">
            <a href="https://www.facebook.com/generaldesegurosoficial/" rel="noreferrer" target="_blank"><img src={facebookWhiteSVG} alt="Facebook" /></a>
            <a href="https://www.instagram.com/generaldesegurosoficial/" rel="noreferrer" target="_blank"><img src={instagramWhiteSVG} alt="Instagram" /></a>
            <a href="https://www.youtube.com/user/generaldesegurosmx" rel="noreferrer" target="_blank"><img src={youtubeWhiteSVG} alt="YouTube" /></a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FooterContainer;
